/* Funnel – scripts : galerie, variantes, panier tiroir, barre collante, avis, vidéo */
(function () {
  'use strict';

  var routes = window.fnRoutes || { cartAdd: '/cart/add.js', cartChange: '/cart/change.js', cart: '/cart.js', root: '/' };

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || window.fnMoneyFormat || '{{amount}} €';
    function delimit(number, precision, thousands, decimal) {
      if (isNaN(number) || number == null) return '0';
      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return parts[1] ? whole + decimal + parts[1] : whole;
    }
    var match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var value = '';
    switch (match ? match[1] : 'amount') {
      case 'amount_no_decimals': value = delimit(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = delimit(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = delimit(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = delimit(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = delimit(cents, 0, ' ', ','); break;
      case 'amount_with_apostrophe_separator': value = delimit(cents, 2, "'", '.'); break;
      default: value = delimit(cents, 2, ',', '.');
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  /* ---------- Galerie ---------- */
  function initGallery(root) {
    var track = root.querySelector('[data-fn-gallery-track]');
    if (!track) return null;
    var slides = track.children;
    var thumbs = root.querySelectorAll('.fn-gallery__thumb');

    function goTo(index) {
      if (!slides[index]) return;
      track.scrollTo({ left: slides[index].offsetLeft, behavior: 'smooth' });
    }
    function current() {
      return Math.round(track.scrollLeft / track.clientWidth);
    }
    function setActive(index) {
      thumbs.forEach(function (t, i) {
        t.classList.toggle('is-active', i === index);
        if (i === index && t.parentNode.scrollTo) {
          t.parentNode.scrollTo({ left: t.offsetLeft - t.parentNode.clientWidth / 2 + t.clientWidth / 2, behavior: 'smooth' });
        }
      });
    }

    var prev = root.querySelector('[data-fn-gallery-prev]');
    var next = root.querySelector('[data-fn-gallery-next]');
    if (prev) prev.addEventListener('click', function () { goTo(Math.max(0, current() - 1)); });
    if (next) next.addEventListener('click', function () { goTo(current() + 1 >= slides.length ? 0 : current() + 1); });
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { goTo(parseInt(t.dataset.index, 10)); });
    });
    var timer;
    track.addEventListener('scroll', function () {
      clearTimeout(timer);
      timer = setTimeout(function () { setActive(current()); }, 60);
    }, { passive: true });

    return {
      goToMedia: function (mediaId) {
        var slide = track.querySelector('[data-media-id="' + mediaId + '"]');
        if (slide) goTo(parseInt(slide.dataset.index, 10));
      }
    };
  }

  /* ---------- Produit ---------- */
  function initProduct(section) {
    var gallery = initGallery(section.querySelector('[data-fn-gallery]') || section);
    var variantsEl = section.querySelector('[data-fn-variants]');
    var picker = section.querySelector('[data-fn-variant-picker]');
    var variants = variantsEl ? JSON.parse(variantsEl.textContent) : [];

    function selectedOptions() {
      return Array.prototype.map.call(picker.querySelectorAll('.fn-option'), function (fs) {
        var checked = fs.querySelector('input:checked');
        return checked ? checked.value : null;
      });
    }

    function updateVariant(variant) {
      section.querySelectorAll('[data-fn-variant-id]').forEach(function (i) { i.value = variant ? variant.id : ''; });
      section.querySelectorAll('[data-fn-price-current]').forEach(function (el) {
        if (variant) el.textContent = formatMoney(variant.price);
      });
      var compare = section.querySelector('[data-fn-price-compare]');
      if (compare && variant) {
        var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        compare.hidden = !onSale;
        if (onSale) compare.textContent = formatMoney(variant.compare_at_price);
      }
      var badge = section.querySelector('[data-fn-price-badge]');
      if (badge && variant) {
        var saving = variant.compare_at_price > variant.price ? Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price) : 0;
        badge.hidden = saving === 0;
        badge.textContent = badge.dataset.template.replace('[%]', saving + '%');
      }
      section.querySelectorAll('[data-fn-atc]').forEach(function (btn) {
        var available = variant && variant.available;
        btn.disabled = !available;
        var label = btn.querySelector('[data-fn-atc-label]');
        if (label) label.textContent = available ? label.dataset.label : label.dataset.soldout;
      });
      if (variant) {
        if (variant.featured_media && gallery) gallery.goToMedia(variant.featured_media.id);
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    if (picker) {
      picker.addEventListener('change', function (e) {
        var fs = e.target.closest('.fn-option');
        if (fs) fs.querySelector('[data-fn-option-value]').textContent = e.target.value;
        var opts = selectedOptions();
        var variant = variants.find(function (v) {
          return v.options.every(function (o, i) { return o === opts[i]; });
        });
        updateVariant(variant);
      });
    }

    var form = section.querySelector('[data-fn-product-form]');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var buttons = section.querySelectorAll('[data-fn-atc]');
        var error = form.querySelector('[data-fn-error]');
        buttons.forEach(function (b) { b.classList.add('is-loading'); });
        if (error) error.hidden = true;
        fetch(routes.cartAdd, {
          method: 'POST',
          headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: new FormData(form)
        })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            if (data.status && data.description) throw new Error(data.description);
            return refreshCart(true);
          })
          .catch(function (err) {
            if (error) { error.textContent = err.message; error.hidden = false; }
          })
          .finally(function () {
            buttons.forEach(function (b) { b.classList.remove('is-loading'); });
          });
      });
    }

    /* Barre collante */
    var sticky = section.querySelector('[data-fn-sticky]');
    var mainBtn = form && form.querySelector('[data-fn-atc]');
    if (sticky && mainBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var entry = entries[0];
        var show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        sticky.querySelectorAll('button').forEach(function (b) { b.tabIndex = show ? 0 : -1; });
      }).observe(mainBtn);
    }
  }

  /* ---------- Panier tiroir ---------- */
  var drawer, lastFocus;

  function openCart() {
    drawer = drawer || document.querySelector('[data-fn-drawer]');
    if (!drawer) { window.location.href = routes.cart.replace('.js', ''); return; }
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('fn-lock');
    var panel = drawer.querySelector('.fn-drawer__panel');
    if (panel) panel.focus();
  }

  function closeCart() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('fn-lock');
    if (lastFocus) lastFocus.focus();
  }

  function refreshCart(open) {
    var sectionsUrl = routes.root.replace(/\/$/, '') + '/?sections=fn-cart-drawer';
    return Promise.all([
      fetch(sectionsUrl).then(function (r) { return r.json(); }),
      fetch(routes.cart, { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); })
    ]).then(function (res) {
      var html = res[0]['fn-cart-drawer'];
      var cart = res[1];
      var target = document.querySelector('[data-fn-drawer-content]');
      if (html && target) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-fn-drawer-content]');
        if (fresh) target.innerHTML = fresh.innerHTML;
      }
      document.querySelectorAll('[data-fn-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count;
        el.hidden = cart.item_count === 0;
      });
      document.dispatchEvent(new CustomEvent('fn:cart-updated', { detail: cart }));
      if (open) openCart();
    });
  }

  function changeLine(key, quantity) {
    var panel = document.querySelector('.fn-drawer__panel');
    if (panel) panel.classList.add('is-loading');
    return fetch(routes.cartChange, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function () { return refreshCart(false); })
      .finally(function () { if (panel) panel.classList.remove('is-loading'); });
  }

  function addVariant(id) {
    return fetch(routes.cartAdd, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: 1 }] })
    }).then(function () { return refreshCart(true); });
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-fn-cart-open]')) { e.preventDefault(); openCart(); return; }
    if (e.target.closest('[data-fn-cart-close]')) { e.preventDefault(); closeCart(); return; }

    var qty = e.target.closest('[data-fn-qty]');
    if (qty) {
      var line = qty.closest('[data-key]');
      if (line) changeLine(line.dataset.key, parseInt(qty.dataset.fnQty, 10));
      return;
    }

    var add = e.target.closest('[data-fn-add]');
    if (add) { add.classList.add('is-loading'); addVariant(add.dataset.fnAdd); return; }

    var more = e.target.closest('[data-fn-reviews-more]');
    if (more) {
      var grid = more.closest('section').querySelector('[data-fn-reviews]');
      grid.querySelectorAll('[data-fn-review-more]').forEach(function (r) { r.hidden = false; });
      more.remove();
      return;
    }

    var video = e.target.closest('[data-fn-video]');
    if (video) {
      var src = video.dataset.type === 'vimeo'
        ? 'https://player.vimeo.com/video/' + video.dataset.id + '?autoplay=1'
        : 'https://www.youtube.com/embed/' + video.dataset.id + '?autoplay=1&rel=0';
      var iframe = document.createElement('iframe');
      iframe.src = src;
      iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
      iframe.allowFullscreen = true;
      iframe.title = 'Vidéo';
      video.replaceWith(iframe);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) closeCart();
  });

  /* Les liens ancres (ex. #MainContent) défilent en douceur */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href^="#"]');
    if (!a || a.getAttribute('href').length < 2) return;
    var el = document.querySelector(a.getAttribute('href'));
    if (el) { e.preventDefault(); el.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
  });

  function init() {
    document.querySelectorAll('[data-fn-product]').forEach(initProduct);
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.querySelector('[data-fn-product]');
    if (s) initProduct(s);
  });

  window.fnCart = { open: openCart, close: closeCart, refresh: refreshCart };
})();
